import React from 'react';
import { History } from 'lucide-react';
import { HistorialPanel } from './HistorialPanel';

export default function ArcaHistorial() {
  return (
    <div className="p-6 max-w-6xl mx-auto space-y-6" data-testid="arca-historial-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><History size={22} /> Historial ARCA</h1>
        <p className="text-slate-500 text-sm mt-1">Todas las consultas realizadas a los servicios de ARCA. Hacé clic en una fila para ver el detalle.</p>
      </div>
      <HistorialPanel showFilter limit={200} />
    </div>
  );
}
